import moment from "moment";
import React, { useState, useRef, useEffect } from "react";
import { useKeyEscClose } from "../../common/escClose/escClose";
import { useInvoice } from "../../Context/NewContext/InvoiceContext";
import { ReactComponent as CheckIcon } from "../../Img/Invoice/check_black.svg";
import { ReactComponent as NoticeIcon } from "../../Img/Invoice/notice.svg";
import fileIcon from "../../Img/Invoice/file.png";
import styles from "./EditRateInfo.module.scss";
import Cookies from "js-cookie";
export default function EditRateInfo({
  date,
  setIsEditRateInfoClick,
  rateInfo,
}) {
  const { addRateInfo } = useInvoice();
  const [googleAdsExchange, setGoogleAdsExchange] = useState(0);
  const [googleIapExchange, setGoogleIapExchange] = useState(0);
  const [isFile, setIsFile] = useState(false);
  const [isEditClick, setIsEditClick] = useState(false);
  const [isGoogleAds, setIsGoogleAds] = useState(false);
  const [isGoogleIap, setIsGoogleIap] = useState(false);
  const fileInputRef = useRef(null);
  const googleAdsRef = useRef(null);
  const googleIapRef = useRef(null);
  const [fileName, setFileName] = useState("No file chosen");
  const formData = new FormData();
  useEffect(() => {
    setGoogleAdsExchange(rateInfo.googleUARate);
    setGoogleIapExchange(rateInfo.googleIAPRate);
  }, [rateInfo]);
  useEffect(() => {
    const mouseDownHandler = (e) => {
      if (googleAdsRef.current.contains(e.target)) {
        setIsGoogleAds(true);
      } else {
        setIsGoogleAds(false);
      }
    };
    document.addEventListener("mousedown", mouseDownHandler);
    return () => document.removeEventListener("mousedown", mouseDownHandler);
  });
  useEffect(() => {
    const mouseDownHandler = (e) => {
      if (googleIapRef.current.contains(e.target)) {
        setIsGoogleIap(true);
      } else {
        setIsGoogleIap(false);
      }
    };
    document.addEventListener("mousedown", mouseDownHandler);
    return () => document.removeEventListener("mousedown", mouseDownHandler);
  });
  const onChange = (e) => {
    const { id, value, files } = e.target;
    switch (id) {
      case "google_ads_input":
        setGoogleAdsExchange(value);

        return;
      case "google_iap_input":
        setGoogleIapExchange(value);

        return;
      case "apple_iap_file":
        formData.append("file", files[0]);

        setIsFile(formData.has("file"));
        setFileName(files[0].name);
        return;
      default:
        setGoogleAdsExchange(0);
    }
  };
  const onEditRateClick = () => {
    setIsEditClick(true);
    const blob = new Blob([fileInputRef?.current?.files[0]], {
      type: fileInputRef?.current?.files[0]?.type,
    });
    formData.append("file", blob, fileInputRef.current?.files[0]?.name);
    formData.append("month", date);
    formData.append("googleUARate", googleAdsExchange);
    formData.append("googleIapRate", googleIapExchange);
    addRateInfo(formData).then((res) => {
      if (res.status === 201) {
        formData.delete("file");
        formData.delete("month");
        formData.delete("googleUARate");
        formData.delete("googleIapRate");
        window.location.reload();
      } else if (res.status === 401) {
        Cookies.remove("Authentication");
        window.location.reload();
      } else {
        setIsEditClick(false);
        alert(res.data.message);
        formData.delete("file");
        formData.delete("month");
        formData.delete("googleUARate");
        formData.delete("googleIapRate");
      }
    });
  };
  useKeyEscClose(() => {
    setIsEditRateInfoClick(false);
  });

  return (
    <section className={styles.container}>
      <section className={styles.rate_info_contents}>
        <h3>Monthly Exchange Rate</h3>
        <section>
          <h2>{moment(date).format("MMMM, YYYY")}</h2>
          <div className={styles.alert_text}>
            <NoticeIcon />
            <p>
              Please provide the exchange rate for{" "}
              {moment(date).subtract(2, "month").format("MMMM")}.
            </p>
          </div>
          <section className={styles.rate_insert_section}>
            <section className={styles.google_ads}>
              <p>
                <p>Google Ads(UA)</p>
                <p>*</p>
              </p>
              <label
                ref={googleAdsRef}
                data-content={isGoogleAds ? "active" : "inactive"}
              >
                <p>1USD =</p>
                <input
                  type="text"
                  id="google_ads_input"
                  onChange={onChange}
                  value={googleAdsExchange ? googleAdsExchange : "0.00"}
                  placeholder="0.00"
                />
                <p>KRW</p>
              </label>
            </section>
            <section className={styles.google_iap}>
              <p>
                <p>Google IAP</p> <p>*</p>
              </p>
              <label
                ref={googleIapRef}
                data-content={isGoogleIap ? "active" : "inactive"}
              >
                <p>1USD =</p>
                <input
                  type="text"
                  id="google_iap_input"
                  onChange={onChange}
                  value={googleIapExchange ? googleIapExchange : "0.00"}
                  placeholder="0.00"
                />
                <p>KRW</p>
              </label>
            </section>
            <section className={styles.apple_iap}>
              <p>
                <p>Apple IAP</p> <p>*</p>
              </p>
              <div className={styles.apple_iap_file_upload}>
                <p data-content={isFile && "active"}>
                  {isFile && <img src={fileIcon} alt="icon" />}
                  {fileName}
                </p>
                {isFile && <CheckIcon />}
                <label>
                  Upload File
                  <input
                    type="file"
                    accept=".csv"
                    id="apple_iap_file"
                    onChange={onChange}
                    ref={fileInputRef}
                  />
                </label>
              </div>
            </section>
          </section>
          <section className={styles.buttons}>
            <button onClick={() => setIsEditRateInfoClick(false)}>
              <p>Cancel</p>
            </button>
            <button onClick={isEditClick ? undefined : onEditRateClick}>
              <p>Edit</p>
            </button>
          </section>
        </section>
      </section>
    </section>
  );
}
